import { render, staticRenderFns } from "./DayNutrition.vue?vue&type=template&id=4b58223c&scoped=true&"
import script from "./DayNutrition.vue?vue&type=script&lang=js&"
export * from "./DayNutrition.vue?vue&type=script&lang=js&"
import style0 from "./DayNutrition.vue?vue&type=style&index=0&id=4b58223c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58223c",
  null
  
)

export default component.exports